import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'
import styled from 'styled-components'
import parse from 'html-react-parser'
import GoogleMapReact from 'google-map-react'
import { IoMdPin } from 'react-icons/io'
import { device } from '../components/Breakpoints'
import { Breadcrumb } from '../components/Breadcrumb'
import { colors } from '../components/Colors'
import PageHeader from '../components/PageHeader'
import Layout from '../components/Layout'
import VejaTambem from '../components/VejaTambem'

const Container = styled.section`
  width: 100%;
  margin-bottom: 2em;
`

const GroupContent = styled.section`
  padding: 2em 0;
  iframe {
    width: 100%;
    height: 460px;
    margin: 0 0 1em 0;
    @media ${device.mobileL} {
      height: 260px;
    }
  }
  @media ${device.mobileL} {
    padding: 2em;
    p,
    h2 {
      text-align: left;
    }
  }
  .padding {
    padding: 1.5em 0 2.5em 0;
  }
  .inner {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    @media ${device.mobileL} {
      flex-wrap: wrap;
    }
  }
  .quadro {
    background-color: #ffffff;
    color: #8e8fc7;
    padding: 1em;
    box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.4);
  }
  .atendimento {
    width: 100%;
    p {
      display: inline;
      color: #ffffff;
      font-size: 0.8em;
    }
    .central {
      display: flex;
      align-items: center;
      h3 {
        color: #4a4a4a;
      }
      p {
        display: block;
        margin: 2px;
      }
      div {
        width: 100%;
        @media ${device.mobileL} {
          display: block;
        }
      }
      .map {
        width: 100%;
        height: 180px;
        margin-bottom: 10px;
        border: 1px solid #148581;
        @media ${device.mobileL} {
          position: static;
          margin-bottom: 1em;
          width: 100%;
          height: 200px;
        }
      }
      @media ${device.mobileL} {
        display: block;
      }
    }
  }
  :nth-of-type(2) {
    padding-top: 0;
  }
  :nth-of-type(3) {
    background: ${colors.lilasGradiente};
    color: #ffffff;
  }
  :nth-of-type(4) {
    h2 {
      color: #8e8fc7;
    }
    a {
      text-decoration: none;
      color: #8e8fc7;
    }
  }
  :nth-of-type(5) {
    background: ${colors.laranjaGradienteReverso};
    color: #ffffff;
    h3 {
      color: #fff8d1;
    }
  }
`
const Map = ({ text }) => (
  <div>
    <IoMdPin size="2em" color="red" />
  </div>
)

export const UtiAdultoTemplate = ({
  title,
  content,
  slug,
  image,
  color,
  area = 'Estrutura',
  sessoes,
}) => {
  const crumbs = [
    { id: 1, link: '/', title: 'Home', icon: true },
    { id: 2, link: '#', title: area, icon: true },
    { id: 3, link: slug, title },
  ]
  return (
    <>
      <Container>
        <Breadcrumb crumbs={crumbs} />

        <PageHeader
          title={title}
          content={content}
          image={image}
          color={color}
          height="165px"
          txtColor="cinza"
          right="0px"
          bottom="0px"
          imgWidth="43.7%"
          overflow="visible"
          imgInner
          mobileTop="-10.5%"
        />
        <GroupContent>
          <div className="padding center">
            {parse(sessoes[0].texto)}
            {parse(sessoes[1].texto)}
          </div>
        </GroupContent>
        <GroupContent>
          <div className="inner center">
            <div>
              <h2>{parse(sessoes[2].tituloDaSessao)}</h2>
              {parse(sessoes[2].texto)}
              {sessoes[3].listaDeItens.map((item, index) => (
                <div className="quadro" key={index}>
                  {parse(item.item)}
                </div>
              ))}
            </div>
          </div>
        </GroupContent>
        <GroupContent>
          <div className="inner center">
            <div>
              <h2>{parse(sessoes[4].tituloDaSessao)}</h2>
              {parse(sessoes[4].texto)}
            </div>
          </div>
        </GroupContent>
        <GroupContent>
          <div className="inner center">
            <div className="atendimento">
              <div>
                <h3>Visita UTI Adulto</h3>
              </div>
              <div className="central">
                <div>
                  <div>
                    <p>Todos os dias, das 14h às 15h - somente uma pessoa</p>
                    <p>Rua do Paraíso, 432 - Paraíso</p>
                  </div>
                </div>
                <div>
                  <div className="map">
                    <GoogleMapReact
                      bootstrapURLKeys={{
                        key: 'AIzaSyCLOHkYMoPTOSfoQxhwpV4wXbo1EkYJvqI',
                      }}
                      yesIWantToUseGoogleMapApiInternals
                      defaultCenter={{ lat: -23.5740475, lng: -46.6392942 }}
                      defaultZoom={16}
                    >
                      <Map lat={-23.5740475} lng={-46.6392942} />
                    </GoogleMapReact>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </GroupContent>
      </Container>
    </>
  )
}

UtiAdultoTemplate.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string,
}

const UtiAdulto = ({ data, location }) => {
  const { siteMetadata: site } = data.site
  const { wpPage: page } = data
  const image = page.opEsDaPGina.imagem ? page.opEsDaPGina.imagem.sourceUrl : ''
  const area = location.state ? location.state.area : page.opEsDaPGina.area
  const { paginasRelacionadas } = page.opEsDaPGina
  const { sessaoCustomizada: sessoes } = page.SessoesCustomizadas
  const description = page.excerpt
    ? page.excerpt.replace(/<\/?[^>]+(>|$)/g, '').replace(/\n/g, '')
    : ''

  return (
    <Layout title={`${page.title} – ${site.title}`} description={description}>
      <UtiAdultoTemplate
        title={page.title}
        content={page.content}
        image={image}
        slug={page.slug}
        color={page.opEsDaPGina.corDoCabecalho}
        area={area}
        sessoes={sessoes}
      />
      <VejaTambem relatedPages={paginasRelacionadas} />
    </Layout>
  )
}

UtiAdulto.propTypes = {
  data: PropTypes.object.isRequired,
}

export default UtiAdulto

export const UtiAdultoQuery = graphql`
  query UtiAdultoById($id: String!) {
    site {
      siteMetadata {
        url
        title
      }
    }
    wpPage(id: { eq: $id }) {
      title
      content
      slug
      excerpt
      SessoesCustomizadas {
        sessaoCustomizada {
          listaDeItens {
            item
          }
          texto
          tituloDaSessao
          imagemDaSessao {
            sourceUrl
            localFile {
              childImageSharp {
                fluid {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
        }
      }
      opEsDaPGina {
        corDoCabecalho
        area
        imagem {
          sourceUrl
        }
        paginasRelacionadas {
          ... on WpPage {
            id
            title
            slug
          }
        }
      }
    }
  }
`
